module.exports = __webpack_public_path__ + "static/campus-f63e513ef2eaaa1a337f0ceac0022be1.jpeg";